import { render, staticRenderFns } from "./history-detailed.vue?vue&type=template&id=781804fe&scoped=true&"
import script from "./history-detailed.vue?vue&type=script&lang=js&"
export * from "./history-detailed.vue?vue&type=script&lang=js&"
import style0 from "./history-detailed.vue?vue&type=style&index=0&id=781804fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781804fe",
  null
  
)

export default component.exports